import React, { useRef } from 'react';
import { attachMessages } from '../i18n';
import { useIntl } from 'react-intl';
import { Item } from './Item';
import { IAttachItemProps } from '../../types';
import { ImageIcon } from 'src/components/Icons/ImageIcon';

export const AttachImg = ({ onSelect }: IAttachItemProps) => {
	const imageInputRef = useRef<HTMLInputElement>(null);
	const intl = useIntl();
	const imageText = intl.formatMessage(attachMessages.image);

	return (
		<Item
			icon={<ImageIcon />}
			text={imageText}
			className="image"
			onClick={() => imageInputRef.current?.click()}
		>
			<input
				type="file"
				accept="image/*"
				hidden
				ref={imageInputRef}
				onChange={onSelect}
			/>
		</Item>
	);
};
